var _defs, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew199({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.a,.b{stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.55,5.5a3.51,3.51,0,0,0,0,4.95L8,8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.55,10.45a3.49,3.49,0,0,0,5,0L8,8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.55,5.5,8,8,10.5,5.5A3.49,3.49,0,0,0,5.55,5.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.5,10.45a3.49,3.49,0,0,0,0-4.95L8,8Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.24,
    y1: 6.9,
    x2: 15.68,
    y2: 6.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.24,
    y1: 9.05,
    x2: 15.68,
    y2: 9.05
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15.68,
    y1: 5.33,
    x2: 15.68,
    y2: 10.62
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.82,
    y1: 9.05,
    x2: 0.38,
    y2: 9.05
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.82,
    y1: 6.9,
    x2: 0.38,
    y2: 6.9
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.38,
    y1: 10.62,
    x2: 0.38,
    y2: 5.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew199);
export default __webpack_public_path__ + "static/media/Symbolpack_New_199.0aeb003e222364bb52ae7e1936b2e347.svg";
export { ForwardRef as ReactComponent };